import React from 'react';
import GRN from '../grn/GRN';

const InvGRN = () => {
  return <GRN grnType="JW" />;
};

export default InvGRN;
